import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
    backgroundColor: theme.colors.modal__background_primary,
    maxWidth: 580
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6)
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  tip: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: theme.spacing(2)
  },
  tipLabel: {
    fontWeight: 600
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
});

export default makeStyles(styles);
